<template>
    <div class="videoPreview">
        <div class="demo-upload-list" v-for="(item, index) in uploadList" :key="index">
            <template v-if="item">
                <img :src="item">
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline"  @click.native="handleCustomOption(item)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(index)"></Icon>
                </div>
            </template>

        </div>
        <Upload ref="upload" :show-upload-list="false" accept=".gif,.webp,.jpg, .jpeg, .png" :max-size="maxSize || 2048"
                :before-upload="handleBeforeUpload" type="drag" action="/" style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                    <Icon v-if="!uploadLoading" type="ios-camera" size="20"></Icon>
                    <Progress :percent="percent" hide-info></Progress>
              </div>
            </Upload>
    </div>
</template>

<script>
// import image from '@/assets/images/image.png'
import { upload } from '@/api/common'
import { Message } from 'view-design';
export default {
  name: 'fileUpload',
  props: {
    src: null,
    width: null,
    height: null,
    type: null,
    multi: null,
    btnWidth: null,
    accept: '',
    uploadList: [],
    radio: null,
    index: Number,
    showSlot: Boolean,
    title: { type: String, default: '上传' },
    maxSize: { type: Number, default: 0 }
  },
  data() {
    return {
      uploadLoading: false,
      percent: 0
    }
  },
  methods: {
    async getFile(event) {
      var file = event.target.files
      let name = file[0].name
      const formData = new FormData()
      formData.append('file', file[0])
      this.uploadLoading = true
      upload(formData).then(({ data }) => {
        this.uploadLoading = false
        console.log(data)

        this.$emit('handleSuccess', data)
      }).catch(() => {
        this.uploadLoading = false
      })
    },
    handleCustomOption(item){
      this.$viewerApi({images:[item]})
      this.$emit('custom')
    },
    handeCheckRadio(file){
      return new Promise((r,j)=>{
        if(this.radio){
          const reader = new FileReader();
          reader.onload = (e)=>{
            const img = new Image()
            img.onload = ()=>{
              const width = img.width
              const height = img.height
              if((width / height * 10).toFixed(1)!= (this.radio*10).toFixed(1)){
                this.$Message.error('不符合图片大小要求')
                j()
              }else{
                r()
              }
            }
            img.src=e.target.result
          }
          reader.readAsDataURL(file)
        }else{
          r()
        }
      })
    },
    async handleBeforeUpload(file) {
      if (this.maxSize > 0) {
        const fileSizeKB = file.size / 1024
        if (fileSizeKB > this.maxSize) {
          this.$Message.error(`图片大小不能超过${this.maxSize}KB`)
          return false
        }
      }
      await this.handeCheckRadio(file)
      const formData = new FormData()
      formData.append('file', file)
      this.uploadLoading = true
      const config = {
        onUploadProgress: progressEvent => {
          // progressEvent.loaded  ==> 已上传的大小
          //  progressEvent.total ==>  文件大小
          console.log(progressEvent)

          const percentCompleted = Math.round((progressEvent.loaded * 100) /
               progressEvent.total)
          // 进度条的数字
          this.percent = percentCompleted
        }
      }
      upload(formData, config).then(({ data }) => {
        this.percent = 100
        this.uploadLoading = false
        this.percent = 0
        this.$emit('handleSuccess', data)
      }).catch(() => {
        this.uploadLoading = false
        this.percent = 0
      })
      return false
    },
    handleRemove(index) {
      this.$emit('hanldDel', index)
    },
    clearFile() {
      this.$refs.upload.value = null
    }
  }
}
</script>

<style scoped>
.demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
}

.demo-upload-list img {
    width: 100%;
    height: 100%;
}

.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}

.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>